import { render, staticRenderFns } from "./RoutePointCom.vue?vue&type=template&id=b4ff5ba0&scoped=true"
import script from "./RoutePointCom.vue?vue&type=script&lang=js"
export * from "./RoutePointCom.vue?vue&type=script&lang=js"
import style0 from "./RoutePointCom.vue?vue&type=style&index=0&id=b4ff5ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ff5ba0",
  null
  
)

export default component.exports